// extracted by mini-css-extract-plugin
export default {"howItWorksWrapper":"HowItWorks_howItWorksWrapper__YZcdj","stepWrapper":"HowItWorks_stepWrapper__re3kz"};